import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

export default function Products() {
  const [produtos, setProdutos] = useState([]);

  useEffect(() => {
    api.get('/produtos')
      .then(r => setProdutos(r.data))
      .catch(err => console.error('Erro ao buscar produtos:', err));
  }, []);

  return (
    <main style={{ padding: '28px 20px', maxWidth: 1100, margin: '0 auto', fontFamily: 'Poppins, sans-serif' }}>
      <h2 style={{ fontSize: '1.7rem', fontWeight: 800, color: '#1a2a4a', marginBottom: 24 }}>
        <i className="fas fa-graduation-cap" style={{ color: '#1e90ff', marginRight: 10 }} />
        Cursos e Produtos
      </h2>

      {produtos.length === 0 && (
        <p style={{ color: '#90a4ae', textAlign: 'center', padding: '40px 0' }}>
          Carregando produtos...
        </p>
      )}

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        gap: 24,
      }}>
        {produtos.map(p => (
          <article key={p.id} style={{
            background: '#fff',
            borderRadius: 18,
            overflow: 'hidden',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            display: 'flex',
            flexDirection: 'column',
            transition: 'transform 0.25s, box-shadow 0.25s',
          }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 10px 28px rgba(30,144,255,0.15)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)'; }}
          >
            {/* Imagem do produto */}
            <div style={{ height: 200, background: '#e2e8f0', overflow: 'hidden', position: 'relative' }}>
              {p.imagem ? (
                <img
                  src={`/uploads/produtos/${p.imagem}`}
                  alt={p.nome}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  onError={e => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <div style={{
                display: p.imagem ? 'none' : 'flex',
                width: '100%', height: '100%',
                alignItems: 'center', justifyContent: 'center',
                background: 'linear-gradient(135deg, #dbeafe, #e0e7ff)',
                color: '#94a3b8', fontSize: '2.5rem',
              }}>
                <i className="fas fa-graduation-cap" />
              </div>
            </div>

            {/* Corpo */}
            <div style={{ padding: '16px 18px', flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
              <h3 style={{ fontSize: '1rem', fontWeight: 700, color: '#1a2a4a', margin: 0 }}>{p.nome}</h3>
              {p.descricao && (
                <p style={{ fontSize: '0.85rem', color: '#64748b', flex: 1, fontWeight: 400, lineHeight: 1.5 }}>
                  {p.descricao.length > 80 ? p.descricao.slice(0, 80) + '...' : p.descricao}
                </p>
              )}
              <div style={{
                display: 'flex', alignItems: 'center',
                justifyContent: 'space-between', marginTop: 'auto', paddingTop: 10,
              }}>
                <span style={{ fontSize: '1.1rem', fontWeight: 800, color: '#1e90ff' }}>
                  {p.precoFormatado}
                </span>
                <Link
                  to={`/produto/${p.id}`}
                  style={{
                    padding: '8px 16px',
                    background: 'linear-gradient(135deg, #1e90ff, #16c2fb)',
                    color: '#fff',
                    borderRadius: 10,
                    textDecoration: 'none',
                    fontSize: '0.85rem',
                    fontWeight: 700,
                    transition: 'opacity 0.2s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.opacity = '0.86'}
                  onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                >
                  Ver detalhes
                </Link>
              </div>
            </div>
          </article>
        ))}
      </div>
    </main>
  );
}
